import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import LegacyPaddedContentColumn from 'shared/app/components/legacy-padded-content-column';

import JoinRewardsLink from 'shared/app/components/join-rewards-link';
import SignInLink from 'shared/app/components/signin-link';
import StarbucksRewardsTrademark from 'shared/app/components/starbucks-rewards-trademark';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import styles from './styles.cssm';
import messages from './messages';

const GuestCardHome = ({ configImagesUrl }) => (
  <LegacyPaddedContentColumn className="px0" size="sm">
    <div className="flex justify-center">
      <div className={`pt3 px3 lg-px0 ${styles.content}`}>
        <img alt="" src={`${configImagesUrl}/feed/card_and_stars.png`} />
        <p className="py3">
          <FormattedMessage
            {...messages.content}
            values={{
              starbucksRewardsTrademark: <StarbucksRewardsTrademark />,
            }}
          />
        </p>
        <SignInLink />
        <JoinRewardsLink className="ml3" color="black" />
      </div>
    </div>
  </LegacyPaddedContentColumn>
);

const select = (state) => ({
  configImagesUrl: configImagesUrlSelector(state),
});

export default connect(select)(GuestCardHome);
